import React from 'react';

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  IconButton,
  Typography,
}                     from '@material-ui/core';

import { 
  makeStyles,
}                     from '@material-ui/core/styles';

import {
  MoreVert as MoreVertIcon,
  Storage as StorageIcon,
}                     from '@material-ui/icons';

import {
  PieChart,
}                     from 'react-minimal-pie-chart';

import { 
  fmtBigInteger,
  fmtBytes,
  fmtMetricInteger,
  fmtObjectsPerDayTrend,
  fmtBytesPerDayTrend,
}                     from '../../utils/formatters';

import { 
  ResourcesContext 
}                     from '../../resource';

const totals = 'Total';

const storageResourceTypes =      [ 'LandingZone', 'Datastore' ];
const storageResourceTypeColors = [ 'blue',        'green' ];

const useStyles = makeStyles((theme) => ({
  root: {
      //flexGrow: 1,
  },
  rowHdr: {
    //minWidth: 90,
    textAlign: 'right',
  },
  colHdr: {
    textAlign: 'right',
  },
  colHdrL: {
    textAlign: 'left',
    paddingLeft: '5px',
  },
  tblCell: {
    textAlign: 'right',
  },
  tblCellL: {
    textAlign: 'left',
    paddingLeft: '5px',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

const fmtResourceType = (resourceType) => {
  return (resourceType.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2")).trim();
};

function incrementMetrics(metrics, resourceType, metricName, increment=1) {
  metrics[resourceType][metricName]+=increment;
  metrics[totals][metricName]+=increment;
}

export default function Storage(props) {
  const classes = useStyles();

  const { resources } = React.useContext(ResourcesContext);

  const rows = [...storageResourceTypes, totals];
  
  let storageMetrics = {};
  storageMetrics[totals]={
    name: totals,
    reporting: 0,
    count: 0,
    bytes: 0,
    bytesTrend: 0,
    objects: 0,
    objectsTrend: 0
  };
  storageResourceTypes.forEach( (resourceType, index) => {
    storageMetrics[resourceType]={
      name: fmtResourceType(resourceType),
      reporting: 0,
      count: 0,
      bytes: 0,
      bytesTrend: 0,
      objects: 0,
      objectsTrend: 0,
      color: storageResourceTypeColors[index]
    };
  });

  if(resources) {
    resources.forEach( resource => {
      if (storageResourceTypes.indexOf(resource.ResourceType) >= 0) {
        if (resource._mutationType !== 'REMOVE') {
          incrementMetrics(storageMetrics,resource.ResourceType,'count');
          try {
            let data=resource.Metrics.CloudWatch.Latest.Data;
            incrementMetrics(storageMetrics,resource.ResourceType,'reporting');
            incrementMetrics(storageMetrics,resource.ResourceType,'objects',data.Objects.Value);
            incrementMetrics(storageMetrics,resource.ResourceType,'objectsTrend',data.Objects.Trend);
            incrementMetrics(storageMetrics,resource.ResourceType,'bytes',data.Bytes.Value);
            incrementMetrics(storageMetrics,resource.ResourceType,'bytesTrend',data.Bytes.Trend);
          } catch(e) {}
        }        
      }
    });
  }

  const labelVariant='caption';
  const fieldVariant='body2';
  const totalBytes=fmtBytes(storageMetrics[totals].bytes).split(' ');
  let x=0;

  const reportingPct = Math.floor((storageMetrics[totals].reporting/storageMetrics[totals].count)*100);

  const capacityPie = () => (
      <PieChart style={{ height: '75px' }}
        animate
        lineWidth={30}
        paddingAngle={5}
        lengthAngle={360}
        startAngle={270}
        label={() => {
          return(
            <svg key={x++} viewBox="0 0 100 100" width="100%" height="100%" style={{ height: '75px'}}>
              <text  dominantBaseline="auto" 
                  x="50" y="50" dx="0" dy="0" 
                  textAnchor="middle" 
                  style={{ fontSize: '26px', fontFamily: 'sans-serif', fontWeight: 'bold'}}>
                {Math.round(totalBytes[0])}
              </text>
              <text dominantBaseline="hanging" 
                  x="50" y="60" dx="0" dy="0" 
                  textAnchor="middle" 
                  style={{ fontSize: '16px', fontFamily: 'sans-serif'}}>
                {totalBytes[1]}
              </text>
            </svg>
          );
        }}
        data={storageResourceTypes.map( (resourceType, index) => ({
          title: storageMetrics[resourceType].name,
          value: storageMetrics[resourceType].bytes,
          color: storageResourceTypeColors[index]
        }))}
      />
  );

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={
          <StorageIcon fontSize="large"/>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="Storage Metrics"
        subheader={reportingPct+"% reporting"}
      />
      <CardContent>
        <div className={classes.sectionMobile}>
          {capacityPie()}
          <Grid container>
            { rows.map( key => {
              let data=storageMetrics[key];
              return(
                <React.Fragment key={key}>
                  <Grid item xs={2} className={classes.rowHdr}>
                    <Typography variant={labelVariant} color="textSecondary" noWrap>
                      <span style={{backgroundColor: data.color}}>&nbsp;&nbsp;</span>
                    </Typography>
                  </Grid>
                  <Grid item xs={10} className={classes.tblCellL}>
                    <Typography variant={fieldVariant} color="textPrimary">
                      {data.name} ({fmtBigInteger(data.count)})
                    </Typography>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </div>
        <div className={classes.sectionDesktop}>
          <Grid className={classes.dataCell} container>
            <Grid item xs={9}>
              <Grid container>
  
                <Grid item xs={2} className={classes.colHdr}></Grid>
                <Grid item xs={1} className={classes.colHdr}>
                  <Typography variant={labelVariant} color="textSecondary" noWrap>Count</Typography>
                </Grid>
                <Grid item xs={2} className={classes.colHdr}>
                  <Typography variant={labelVariant} color="textSecondary" noWrap>Objects</Typography>
                </Grid>
                <Grid item xs={2} className={classes.colHdrL}>
                  <Typography variant={labelVariant} color="textSecondary" noWrap>(growth/d)</Typography>
                </Grid>
                <Grid item xs={2} className={classes.colHdr}>
                  <Typography variant={labelVariant} color="textSecondary" noWrap>Bytes</Typography>
                </Grid>
                <Grid item xs={3} className={classes.colHdrL}>
                  <Typography variant={labelVariant} color="textSecondary" noWrap>(growth/d)</Typography>
                </Grid>
  
                { rows.map( key => {
                  let data=storageMetrics[key];
                  return(
                    <React.Fragment key={key}>
                      <Grid item xs={2} className={classes.rowHdr}>
                        <Typography variant={labelVariant} color="textSecondary" noWrap>
                          {data.name}&nbsp;<span style={{backgroundColor: data.color}}>&nbsp;&nbsp;</span>
                        </Typography>
                      </Grid>
                      <Grid item xs={1} className={classes.tblCell}>
                        <Typography variant={fieldVariant} color="textPrimary">
                          {fmtBigInteger(data.count)}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} className={classes.tblCell}>
                        <Typography variant={fieldVariant} color="textPrimary">
                          {fmtMetricInteger(data.objects)}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} className={classes.tblCellL}>
                        <Typography variant={fieldVariant} color="textPrimary">
                          {fmtObjectsPerDayTrend(data.objectsTrend,data.objects, {percentPrecision: 2})}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} className={classes.tblCell}>
                        <Typography variant={fieldVariant} color="textPrimary">
                          {fmtBytes(data.bytes,0)}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} className={classes.tblCellL}>
                        <Typography variant={fieldVariant} color="textPrimary">
                          {fmtBytesPerDayTrend(data.bytesTrend, data.bytes, {percentPrecision: 2})}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  );            
                })}
                
              </Grid>
            </Grid>
            <Grid item xs={3}>
              {capacityPie()}
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
}